<template>
  <div class="">
    <div class="row" style="max-height: 49%;">
      <!--            <umi-order :id="order.Id"></umi-order>-->
      <div class="col-4">

      </div>
      <div class="col-4 text-center">
        <div v-if="order.RecastNumber === 0"><strong>Заказ № {{order.SferaNumber}}</strong></div>
        <div class="text-nowrap" v-else><strong>Переделка заказа №{{order.SferaNumber}} /
          {{order.RecastNumber}}</strong></div>
        <div>Внутренний номер: {{order.LocalNumber ? order.LocalNumber : '-'}}</div>
      </div>
      <div class="col-4 text-right">
        <vue-barcode :value="order.SferaNumber" display-value="false" height="40" width="2">
          Ошибка штрихкода
        </vue-barcode>
      </div>
      <div class="col-6">
        <ul class="list-unstyled m-0">
          <li><strong>{{order.Name}}</strong></li>
          <li>Дополнительно: <strong>{{order.Dops}}</strong></li>
          <li>Цена: <strong>{{order.Price}}</strong></li>
          <li>Кол-во: <strong>{{order.Amount}}</strong></li>
          <li>Сумма: <strong>{{order.Summary}}</strong></li>
        </ul>
      </div>
      <div class="col-6">
        <ul class="list-unstyled m-0">
          <li>Принят: <strong>{{order.ReceivedDate}}</strong></li>
          <li>Партнер: <strong>{{customer.Reception}}</strong></li>
          <li>Объезд: <strong>{{customer.Tour.Name}}</strong></li>
          <li>Дата готовности: <strong>{{order.ReadyDate}}</strong></li>
        </ul>
      </div>
      <div class="col-12">
        Примечание: {{order.Comment}}
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import UmiOrder from '@/admin/modules/Order/_components/UmiOrder';

export default {
  props: {
    order: {},
    customer: {
      type: Object,
      default() {
        return {
          Reception: null,
          Tour: {
            Name: null,
          },
        };
      },
    },
  },
  components: {
    UmiOrder,
    VueBarcode,
  },
  methods: {},
};
</script>
<style>

</style>
